import React, { lazy } from 'react'
import { Route } from 'react-router'
import { Breadcrumb } from '@/components/Breadcrumb/Breadcrumb'
import { LoggedInRoute } from '@/router/LoggedInRoute'
import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))
const BoardIndex = lazy(() => import('./board/Index'))
const FindingsIndex = lazy(() => import('./findings/Index'))
const ConfigIndex = lazy(() => import('./config/Index'))
const ProgrammeIndex = lazy(() => import('./programme/Index'))
const CalendarIndex = lazy(() => import('./calendar/Index'))
const AuditsIndex = lazy(() => import('./audits/Index'))
const AuditorsIndex = lazy(() => import('./auditors/Index'))
const MyActionsIndex = lazy(() => import('./my-actions/Index'))
const ExternalIndex = lazy(() => import('./external/Index'))
const AuthorityMailboxIndex = lazy(() => import('./authority-mailbox/Index'))
const SuppliersIndex = lazy(() => import('./suppliers/Index'))
const GovernanceIndex = lazy(() => import('./governance/Index'))
const LibraryIndex = lazy(() => import('./library/Index'))
const LibraryImport = lazy(() => import('./library/Import'))
const LibraryMatrix = lazy(() => import('./library/Matrix'))
const LibraryMatrixImport = lazy(() => import('./library/MatrixImport'))
const LibraryAlerts = lazy(() => import('./library/Alerts'))
const FindingsSkylegsImport = lazy(() => import('./findings/SkylegsImport'))
const FindingsReassign = lazy(() => import('./findings/Reassign'))

const guarded = (menuItem: `role--${string}`, element: React.ReactNode) => (
  <LoggedInRoute roles={[menuItem]}>{element}</LoggedInRoute>
)

export const ComplianceRouter = React.memo(() => (
  <>
    <Breadcrumb title='id:r.compliance.index' />
    <SubRouter loggedIn roles={['role--compliance']}>
      <Route index element={<Index />} />

      <Route path='library' element={guarded('role--compliance--library', <LibraryIndex />)} />
      <Route
        path='library/import'
        element={guarded('role--compliance--config', <LibraryImport />)}
      />
      <Route
        path='library/matrix/*'
        element={guarded('role--compliance--library', <LibraryMatrix />)}
      />
      <Route
        path='library/matrix/import'
        element={guarded('role--compliance--config', <LibraryMatrixImport />)}
      />
      <Route
        path='library/alerts'
        element={guarded('role--compliance--library', <LibraryAlerts />)}
      />

      <Route path='board' element={guarded('role--compliance--board', <BoardIndex />)} />

      <Route
        path='programme/*'
        element={guarded('role--compliance--programme', <ProgrammeIndex />)}
      />

      <Route path='calendar' element={guarded('role--compliance--calendar', <CalendarIndex />)} />

      <Route path='audits/*' element={guarded('role--compliance--audits', <AuditsIndex />)} />

      {/* Déclarées avant findings/* : la route large capturerait sinon leur segment comme un identifiant. */}
      <Route
        path='findings/skylegs-import'
        element={guarded('role--compliance--config', <FindingsSkylegsImport />)}
      />
      <Route
        path='findings/reassign'
        element={guarded('role--compliance--config', <FindingsReassign />)}
      />
      <Route path='findings/*' element={guarded('role--compliance--findings', <FindingsIndex />)} />

      <Route
        path='my-actions'
        element={guarded('role--compliance--my-actions', <MyActionsIndex />)}
      />

      <Route path='external/*' element={guarded('role--compliance--external', <ExternalIndex />)} />

      <Route
        path='authority-mailbox'
        element={guarded('role--compliance--authority-mailbox', <AuthorityMailboxIndex />)}
      />

      <Route
        path='suppliers/*'
        element={guarded('role--compliance--suppliers', <SuppliersIndex />)}
      />

      <Route path='auditors/*' element={guarded('role--compliance--auditors', <AuditorsIndex />)} />

      <Route
        path='governance/*'
        element={guarded('role--compliance--governance', <GovernanceIndex />)}
      />

      <Route path='config/*' element={guarded('role--compliance--config', <ConfigIndex />)} />
    </SubRouter>
  </>
))
